<div class="container-fluid p-3 ">
  <div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div class="flex gap-3">

        <div class="flex-1">
          <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
            {{stepDetails?.name}}
          </h4>

          <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
            [{{ payload?.proposal_name }}]
          </h5>


        </div>
        <div>

          <span class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all"
            [ngClass]="{
                        'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
                        'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
                        'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
                        'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
                      }">
            <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                          'bg-slate-500': stepDetails?.step_status == 0,
                          'bg-emerald-500': stepDetails?.step_status == 'approved',
                          'bg-amber-500': stepDetails?.step_status == 'recommended',
                          'bg-blue-500': stepDetails?.step_status == 'initiated'
                        }"></span>
            {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
          </span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-2">

       <ng-container *ngIf="stepDetails?.can_edit">
          <button (click)="routeConfig.emit({isRouteConfig: true})"
            class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>
 

  <hr class="my-3" />

  <app-upload-document [isEditable]="stepDetails?.can_edit"></app-upload-document>

</div>